/**
 * Listens for `NOTIFICATION_CLICK` postMessages from the Firebase service worker
 * (see public/firebase-messaging-sw.template.js) and navigates the app to the
 * resolved destination path.
 *
 * The service worker also includes `conversationId` on these messages — that
 * field is consumed by ChatPage.tsx's own listener (unchanged) for chat pushes,
 * which carry no `path`. This hook ignores messages with no non-empty `path`,
 * since those are chat pushes that ChatPage already owns.
 *
 * Must be mounted inside the Router (it calls useNavigate()).
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function useNotificationDeepLink(): void {
  const navigate = useNavigate();

  useEffect(() => {
    if (!navigator.serviceWorker) {
      return;
    }

    const handler = (event: MessageEvent) => {
      const path = event.data?.path;
      if (event.data?.type === 'NOTIFICATION_CLICK' && typeof path === 'string' && path.length > 0) {
        navigate(path);
      }
    };

    navigator.serviceWorker.addEventListener('message', handler);
    return () => navigator.serviceWorker.removeEventListener('message', handler);
  }, [navigate]);
}
